var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0354004,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8021 15.7124C29.8021 15.9312 29.8021 16.1499 29.8021 16.3374C29.8021 22.8062 24.8646 30.2749 15.8646 30.2749C13.0833 30.2749 10.5208 29.4624 8.33333 28.0874C8.70833 28.1187 9.11458 28.1499 9.48958 28.1499C11.7708 28.1499 13.8958 27.3687 15.5833 26.0562C13.4271 26.0249 11.6146 24.5874 11.0208 22.6499C11.3333 22.7124 11.6146 22.7437 11.9583 22.7437C12.3958 22.7437 12.8333 22.6812 13.2396 22.5562C10.9896 22.1187 9.30208 20.1499 9.30208 17.7749C9.30208 17.7437 9.30208 17.7437 9.30208 17.7124C9.95833 18.0874 10.7083 18.3062 11.5208 18.3374C10.2083 17.4624 9.33333 15.9624 9.33333 14.2437C9.33333 13.3374 9.58333 12.4937 9.98958 11.7749C12.3958 14.7437 16.0208 16.6812 20.0833 16.8999C19.9896 16.5562 19.9583 16.1499 19.9583 15.7749C19.9583 13.0562 22.1458 10.8687 24.8646 10.8687C26.2708 10.8687 27.5521 11.4624 28.4271 12.3999C29.5521 12.1812 30.5833 11.7749 31.5521 11.2124C31.1771 12.3687 30.3958 13.3062 29.3958 13.9312C30.3958 13.8062 31.3333 13.5562 32.2083 13.1499C31.5833 14.1499 30.7708 15.0249 29.8021 15.7124Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fcd11c9f7c48da9c26b09ed5f1ba3f8c.svg";
export { ForwardRef as ReactComponent };